import { Col, Row } from 'antd';
import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import { image } from '../../../../../_config/constants/image.constant';
import CustomImage from '../../../../../v2-components/Antd/Image';
import { productDetail } from './constants/product-detail.constant';
import { checkPromotion } from './handle/check-promotion.handle';
import { checkQuantity } from './handle/check-quantity.handle';
import { recipeStatus } from './handle/recipe-status.handle';
import './style.css';

export default function DropdownTable(props) {
	const [imageSrc, setImageSrc] = useState(props?.record.image);
	console.log('record', props.record);
	const handleImageError = () => {
		setImageSrc(image.default);
	};
	return (
		<Row className="margin-row">
			<Col span={8} className="flex-col">
				<span>
					{productDetail[Enviroment.LANGUAGE].code_internal}
					{props?.record?.code_internal}
				</span>
				<span>
					{productDetail[Enviroment.LANGUAGE].id_pharol} {props?.record?.id_pharol}
				</span>
			</Col>
			<Col span={8} className="flex-col">
				<span>
					{productDetail[Enviroment.LANGUAGE].laboratory}
					{props?.record?.laboratory}
				</span>
				<span>
					{productDetail[Enviroment.LANGUAGE].bioequivalent}
					{props?.record?.bioequivalent}
				</span>
				<span>
					{productDetail[Enviroment.LANGUAGE].promotion} {checkPromotion(props?.record?.promotions?.rules?.tag)}
				</span>
				<span>
					{checkQuantity(props?.record?.quantity)}
					{props?.record?.total_product}
				</span>
				<span>
					{productDetail[Enviroment.LANGUAGE].recipe}
					{recipeStatus(props?.record?.validation_product, props?.record?.prescryption_type)}
				</span>
			</Col>
			<Col span={8} className="img-col">
				<CustomImage src={imageSrc} onError={handleImageError} width={100} preview={false} />
			</Col>
		</Row>
	);
}
